import { useEffect } from 'react'
import { useCloverNavStore } from '@/store/cloverNavStore'
import { todayIsoDate } from '@/utils/waterfallCalculator'

/**
 * Seeds Clover left-nav alert counts from the daily nav-status snapshot.
 * Re-fetches once per Chicago calendar day when the tab becomes visible again.
 */
export function useCloverNavStatusPoller() {
  const fetchNavStatus = useCloverNavStore((s) => s.fetchNavStatus)
  const lastFetchedChicagoDate = useCloverNavStore((s) => s.lastFetchedChicagoDate)

  useEffect(() => {
    void fetchNavStatus()
  }, [fetchNavStatus])

  useEffect(() => {
    const maybeFetchForNewChicagoDay = () => {
      if (document.visibilityState === 'hidden') {
        return
      }
      if (todayIsoDate() === lastFetchedChicagoDate) {
        return
      }
      void fetchNavStatus()
    }

    document.addEventListener('visibilitychange', maybeFetchForNewChicagoDay)
    window.addEventListener('focus', maybeFetchForNewChicagoDay)
    return () => {
      document.removeEventListener('visibilitychange', maybeFetchForNewChicagoDay)
      window.removeEventListener('focus', maybeFetchForNewChicagoDay)
    }
  }, [fetchNavStatus, lastFetchedChicagoDate])
}
